import { IonIcon } from "@ionic/react";
import { addOutline } from "ionicons/icons";
import React from "react";

interface CitySupplementBadgeProps {

    /** Bare city name shown in bold (e.g. `Genève`), after the muted `City` qualifier. */
    "city": string;

    /** Tariff community / area name appended after `·` (e.g. `unireso`), omitted when absent. */
    "areaName"?: string;

    /** Dark surface adaptation — the ticket card itself is always light and passes `false`. */
    "isDarkUi": boolean;
}

/**
 * City-Ticket supplement presented as a detachable-coupon badge: dashed
 * tear-off border and a `+` seal overlapping the left edge, marking the
 * supplement as an included extra. The qualifier word ("City") stays muted —
 * the city name and its tariff community carry the visual weight.
 */
export const CitySupplementBadge: React.FC<CitySupplementBadgeProps> = ( { city, areaName, isDarkUi } ) => (
    <span
        className={`relative inline-flex items-center gap-1 rounded-md border border-dashed py-1 pl-5 pr-2 text-[0.62rem] uppercase leading-tight tracking-wider ${ isDarkUi ? "border-sky-400/60 bg-sky-400/10" : "border-sky-500/70 bg-sky-50/70" }`}
    >
        <span className={`font-semibold ${ isDarkUi ? "text-sky-400" : "text-sky-500" }`}>
            City
        </span>
        <span className={`font-bold ${ isDarkUi ? "text-sky-200" : "text-sky-800" }`}>
            {city}
            {areaName !== undefined && areaName !== "" ? ` · ${ areaName }` : ""}
        </span>
        <span
            aria-hidden={true}
            className="absolute -left-[7px] top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center rounded-full bg-sky-600 ring-1 ring-white"
        >
            <IonIcon
                aria-hidden={true}
                className="h-2.5 w-2.5 text-white"
                icon={addOutline}
            />
        </span>
    </span>
);
